import { useState, useEffect } from "react";
import { getJwtTokenFromIdToken } from "../components/pages/auth/AuthFanc";

const useFetchData = <T>(url: string | undefined, dataKey: string | undefined = undefined) => {
  const [data, setData] = useState<T | T[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();
      if (!url) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(url, {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: jwtToken,
          },
        });

        if (!response.ok) {
          throw new Error("Error fetching data");
        }

        const jsonData = await response.json();

        // If dataKey is provided, use it to extract data; otherwise, use jsonData directly
        setData(dataKey ? jsonData[dataKey] : jsonData);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url, dataKey]);

  return { data, isLoading, error };
};

export default useFetchData;
